import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '日本区', href: '/category/zone-jp' },
  { label: '韩国区', href: '/category/zone-kr' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-global-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-heading font-bold text-foreground-900 whitespace-nowrap">
              日韩成人教育
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href
                || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/language"
              className="px-4 py-2 rounded-lg text-sm font-medium bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap"
            >
              浏览课程
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href
                || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-2 mt-2 pt-2 border-t border-background-200">
              <Link
                to="/category/language"
                className="flex-1 px-4 py-3 rounded-lg text-sm font-medium text-center bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors whitespace-nowrap"
              >
                浏览课程
              </Link>
              <Link
                to="/about"
                className="flex-1 px-4 py-3 rounded-lg text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}